if (!customElements.get('whats-included-slider')) {
  customElements.define(
    'whats-included-slider',
    class WhatsIncludedSlider extends HTMLElement {
      connectedCallback() {
        if (this.swiper || typeof Swiper === 'undefined') return;

        this.swiper = new Swiper(this, {
          slidesPerView: 'auto',
          spaceBetween: 10,
          // Swiping is switched off when every item fits on the row.
          watchOverflow: true,
          freeMode: { enabled: true, sticky: false },
          // Trackpad sideways scrolling; vertical wheel still scrolls the page.
          mousewheel: { forceToAxis: true, releaseOnEdges: true },
        });

        // Layout can still shift while the page's stylesheets finish loading.
        if (document.readyState !== 'complete') {
          window.addEventListener('load', () => this.swiper?.update(), { once: true });
        }
      }

      disconnectedCallback() {
        this.swiper?.destroy(true, true);
        this.swiper = null;
      }
    }
  );
}
